export const githubUsername = "KrzysiekWorwa";